import EA from 'helpers/init';

export default EA.Methods.stickyNav = ($this) => {
    const sticky = document.querySelector('.app');

    sticky.classList.add('overflow');
};
